var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tech-title-box"},[_c('div',{staticClass:"tech-title-cron"},[_c('div',{staticClass:"tech-title-text-title"},[_vm._v(_vm._s(_vm.$t('home.banner.title')))]),_c('div',{staticClass:"tech-title-text"},[_vm._v(" "+_vm._s(_vm.$t('common.slogan'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }